import BaseDescriptionField from 'registration/js/base/fields/description';

import template from 'registration/templates/simple/game/fields/description.html';

const DescriptionField = BaseDescriptionField.extend({
    template
});

export default DescriptionField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/simple/fields/description.js